// Domaine public courant. REACT_APP_CANONICAL_HOST (ex. dojova.com) prime ; sinon l'hôte du navigateur ; sinon REACT_APP_BACKEND_URL.
const _env = (process.env.REACT_APP_CANONICAL_HOST || "").trim().replace(/^https?:\/\//, "").replace(/\/$/, "");
const _backend = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const _browser = typeof window !== "undefined" && window.location && window.location.host ? window.location.host : "";
export const PUBLIC_HOST = _env || _browser || _backend.replace(/^https?:\/\//, "") || "dojova.com";
export const PUBLIC_ORIGIN = `https://${PUBLIC_HOST}`;
export const publicUrl = (path = "/") => `${PUBLIC_ORIGIN}${path.startsWith("/") ? path : "/" + path}`;
